/**
 * Wire-format inventory item type. The backend serializes the InventoryItemType enum as a
 * string via JsonStringEnumConverter. The three-value union mirrors the canonical lifecycle:
 * Product (physical stocked goods), Service (no physical fulfilment), Hybrid (mixed).
 */
export type InventoryItemType = 'Product' | 'Service' | 'Hybrid';

export const INVENTORY_ITEM_TYPES: readonly InventoryItemType[] = ['Product', 'Service', 'Hybrid'];

export const INVENTORY_ITEM_TYPE_SERVICE: InventoryItemType = 'Service';

export function isInventoryItemType(value: unknown): value is InventoryItemType {
  return typeof value === 'string' && INVENTORY_ITEM_TYPES.includes(value as InventoryItemType);
}

export function normalizeInventoryItemType(
  value: InventoryItemType | string | null | undefined,
): InventoryItemType {
  return isInventoryItemType(value) ? value : 'Product';
}

export function getInventoryItemTypeLabelKey(
  value: InventoryItemType | string | null | undefined,
): string {
  return `COMPONENTS.GOODS.ITEM_TYPES.${normalizeInventoryItemType(value).toUpperCase()}`;
}
